import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter, LineClamp } from '../../../../global/commonStyle';

interface Props {
  isActive?: boolean;
}

const Details = styled.div`
  ${AlignCenter}
  gap: var(--space-2);
  p {
    ${Typography.body_md}
    color: var(--text-secondary);
    margin: var(--space-0);
    ${LineClamp(1)}
    word-break: break-all;
  }
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
  `)}
`;

const DotIcon = styled.div<Props>`
  padding: ${({ isActive }) => (isActive ? 'var(--space-3)' : 'var(--space-8)')};
  ${FlexCenter}
  ${mobile_xl(css<Props>`
    display: ${({ isActive }) => (isActive ? 'flex' : 'none')};
  `)}
`;

const Dot = styled.div<Props>`
  width: ${({ isActive }) => (isActive ? '6px' : '4px')};
  height: ${({ isActive }) => (isActive ? '6px' : '4px')};
  border-radius: var(--border-radius-full);
  background-color: ${({ isActive }) => (isActive ? 'var(--green)' : 'var(--text-placeholder)')};
`;

const ActiveDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-2);
`;

export { Details, Dot, DotIcon, ActiveDiv };
